import { RootState } from '../store/configureStore';

export const getProductTypes = (state: RootState) => state?.productType?.productTypes;

export const isFetchingProductTypes = (state: RootState) =>
  state?.productType?.isFetchingProductTypes;

export const didFetchingProductTypesFailed = (state: RootState) =>
  state?.productType?.fetchingProductTypesFailed;
